import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import Scrollbars from 'react-custom-scrollbars-2';

class Frame extends Component {
    state = {
        height: 60,
    };

    componentDidMount() {
        this.getHeight();
    }

    getHeight = () => {
        if (window.matchMedia('(max-width: 575px)').matches) {
            this.setState({
                height: 40,
            });
        } else {
            this.setState({
                height: 60,
            });
        }
    };

    render() {
        if (typeof window === 'undefined') {
            return null;
        }
        window.addEventListener('resize', this.getHeight);

        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                <FullWrapper bigPaddings={true} className="topdf-frame" isMargin={false}>
                    <div
                        className="topdf-frame__wrapper"
                        style={{
                            cursor: `url(${'/images/svg/topdf/topdf-frame__kursor.svg'}), auto`,
                        }}
                    >
                        <img
                            className="topdf-frame__cursor"
                            src="/images/svg/topdf/topdf-frame__kursor.svg"
                            alt=""
                            loading="lazy"
                        />
                        <img
                            className="topdf-frame__dots"
                            src="/images/svg/topdf/topdf-frame__dots.svg"
                            alt=""
                            loading="lazy"
                        />
                        <div className="topdf-frame__wrapper-inner">
                            <Scrollbars
                                thumbSize={60}
                                className="topdf-frame__scroll-block"
                                renderTrackVertical={props => (
                                    <div {...props} className="topdf-frame__track-vertical" />
                                )}
                                renderThumbVertical={props => (
                                    <div {...props} className="topdf-frame__thumb-vertical" />
                                )}
                                style={{ maxWidth: 1160, height: `${this.state.height}vh` }}
                            >
                                <div className="topdf-frame__body">
                                    <img
                                        src="/images/pic/topdf/frame__img.png"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                            </Scrollbars>
                        </div>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Frame;
